import React, { useMemo, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { SearchBar } from '@uncinc/react-searchkit';
import type { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';
import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import SearchBarButton from '../../Button/SearchBarButton';
import SearchResetButton from '../../Button/SearchResetButton';

import {
  SCREEN_TABLET,
} from '../../../config/constants';

import '../../SearchGeneral/Styles/_searchbar.scss';

const SearchOcularDBSearchBar: React.FC<SearchBarProps> = (props) => {
  const { className, onSubmit, ...restProps } = props;
  const ref = useRef();

  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => width < SCREEN_TABLET, [width]);

  const classNames = c('SearchOcularDB__SearchBar', className);
  const searchBarPlaceholder = t('components.search_oculardb.search_bar.placeholder');
  const searchBarMobilePlaceholder = t('components.search_oculardb.search_bar.placeholder_mobile');

  return (
    <SearchBar
      {...restProps}
      className={classNames}
      placeholder={isMobile ? searchBarMobilePlaceholder : searchBarPlaceholder}
      button={SearchBarButton}
      showReset
      ref={ref}
      resetProps={{
        button: SearchResetButton,
      }}
      onSubmit={(query) => {
        // Call the passed onSubmit, if we have it.
        if (onSubmit) {
          onSubmit(query);
        }

        // Unblur the focus on submit.
        if (ref.current) {
          // @ts-ignore
          ref.current.blur();
        }
      }}
    />
  );
};

export default SearchOcularDBSearchBar;
